module.exports = __webpack_public_path__ + "static/media/icon_create.20bfe87f.svg";